import { serialize } from '@/@core/libs/serialize/util'
import Http from './http'

export const emailLogsList = (params = {}) => {
	const cleaned = {}
	for (const key in params) {
		if (params[key] !== null && params[key] !== '' && params[key] !== undefined) {
			cleaned[key] = params[key]
		}
	}
	return Http.get(`/email-logs${serialize(cleaned)}`)
}
export const emailLogsMailClasses = () => Http.get('/email-logs/mail-classes')
